import React from "react";
import {useMediaQuery} from "beautiful-react-hooks";
import { Link } from "react-router-dom";

const colors = ["#0088FE", "#00C49F", "#FFBB28"];
const delay = 3500;



const items = [
    {
        "element": <img className="img20224 main_box2 fdfsfjsghsg5536232" src="./banner/free-karmozd.png" alt="کارمزد صفر برای معامله ارزدیجیتال | کمترین کارمزد خرید و فروش ارزدیجیتال"/>

    },
    {
      "element": <img className="img20224 main_box2 fdfsfjsghsg5536232" src="./banner/free-babydoge.png" alt="ارز دیجیتال رایگان "/>

  },
  
    
  


   
    
   
]

export default function BannerSlider() {
  const [index, setIndex] = React.useState(0);
  const timeoutRef = React.useRef(null);
  const isSmall = useMediaQuery('(max-width: 768px)')


  function resetTimeout() {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }

  React.useEffect(() => {
    resetTimeout();
    timeoutRef.current = setTimeout(
      () =>
        setIndex((prevIndex) =>
          prevIndex === items.length - 1 ? 0 : prevIndex + 1
        ),
      delay
    );

    return () => {
      resetTimeout();
    };
  }, [index]);





  function handleNext(){

    let next = index + 1 < items.length ? index + 1 : 0
    setIndex(next)
  }




  function handlePrev(){

    let prev = index - 1 < 0 ? 4 - 1 : index - 1;
      setIndex(prev)

  }

  return (
    <>

    {isSmall?
      <>





    <div className="slideshow2020">

<div
  className="slideshowSlider56"
  style={{ transform: `translate3d(${index * 100}%, 0, 0)` }}
>
<div
      className=""
    >

  {items.map((item, index) => (

    <a href={'/prize-exchange'}>
    

    <div
            className="slide2020"
            key={index}
          >
              {item.element}
    </div>

                  </a>
  ))}
    </div>

</div>









<div className="slideshowDots56">
  {items.map((_, idx) => (
    <div
      key={idx}
      className={`slideshowDot2022${index === idx ? " active" : ""}`}
      onClick={() => {
        setIndex(idx);
      }}
    ></div>
  ))}
</div>
</div>


  
      
      </>

      :


      <></>



  

    }

    </>


  );
}

